import { createAsyncThunk, AnyAction } from "@reduxjs/toolkit"
import { ThunkDispatch } from "redux-thunk"

import i18n from "config/i18n"
import { API } from "redux/api"
import {
  ZlickAuthRequestValues,
  ZlickAuthRequestType,
  ZlickAuthRequestConfirmationValues,
} from "types"

export const createZlickAuthRequest = createAsyncThunk(
  "zlick-uri-request/create",
  async (values: ZlickAuthRequestValues) => {
    const response = await API.post("/zlick_user_auth_requests", values)
    return response.data
  },
)

export const updateZlickAuthRequest = createAsyncThunk(
  "zlick-uri-request/update",
  async (values: ZlickAuthRequestConfirmationValues) => {
    const response = await API.patch("/zlick_user_auth_requests/update", values)
    return response.data
  },
)

export const makeZlickAuthRequest = (values: ZlickAuthRequestValues) => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise<ZlickAuthRequestType>((resolve, reject) => {
      return dispatch(createZlickAuthRequest(values))
        .then(
          ({ payload }) => {
            if (!payload || !payload.zlick_user_auth_request) {
              return reject(payload.error)
            }

            const { id } = payload.zlick_user_auth_request

            resolve({ id })
          },
          () => {
            reject(i18n.t("notice.subscription.session.failure"))
          },
        )
        .catch(() => {
          reject(i18n.t("notice.subscription.session.failure"))
        })
    })
  }
}

export const makeFinishZlickAuthRequest = (
  values: ZlickAuthRequestConfirmationValues,
) => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise<Record<string, never>>((resolve, reject) => {
      return dispatch(updateZlickAuthRequest(values))
        .then(
          ({ payload }) => {
            if (payload.error) {
              return reject(payload.error)
            }

            resolve({})
          },
          () => {
            reject(i18n.t("notice.subscription.session.failure"))
          },
        )
        .catch(() => {
          reject(i18n.t("notice.subscription.session.failure"))
        })
    })
  }
}
